import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, CandlestickChart, FolderOpen, Bell } from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/chart", label: "Chart", icon: CandlestickChart },
  { to: "/plans", label: "Plans", icon: FolderOpen },
  { to: "/alerts", label: "Alerts", icon: Bell },
];

export default function BottomTabBar() {
  return (
    <nav
      data-testid="mobile-bottom-tabbar"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden grid grid-cols-4 border-t backdrop-blur"
      style={{ background: "rgba(10,10,12,.92)", borderColor: "var(--border)", paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`tab-${t.label.toLowerCase()}`}
            className="flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-semibold"
            style={({ isActive }) => ({ color: isActive ? "var(--accent-soft)" : "var(--text-dim)" })}
          >
            {({ isActive }) => (
              <>
                <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
                {t.label}
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
